import React, { useEffect, useState } from "react";
import Axios from "axios";

const TeamDetails = ({ teamId, csv, setCsv }) => {
    const [teamLeader, setTeamLeader] = useState({});
    const [teamMembers, setTeamMembers] = useState([]);
    const getTeamLeader = () => {
        Axios.post(
            "https://ashish.moodi.org/multicity/get_mul_leaders",
            {
                team: teamId,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                setTeamLeader(res.data[0]);
                setCsv(
                    (current) =>
                        current +
                        res.data[0].mcTeamId +
                        "," +
                        res.data[0].userName +
                        "(Leader)," +
                        res.data[0].MI_NO +
                        "," +
                        res.data[0].phone +
                        "," +
                        res.data[0].email +
                        "," +
                        res.data[0].collegeName +
                        "," +
                        res.data[0].cityName +
                        "\n"
                );
            })
            .catch((err) => console.error(err));
    };
    const getTeamDetails = () => {
        Axios.post(
            "https://ashish.moodi.org/multicity/get_mul_members",
            {
                team: teamId,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                setTeamMembers(res.data);
                res.data.forEach((member) => {
                    setCsv(
                        (current) =>
                            current +
                            member.team +
                            "," +
                            member.userName +
                            "," +
                            member.MI_NO +
                            "," +
                            member.phone +
                            "," +
                            member.email +
                            "," +
                            member.collegeName +
                            "," +
                            member.cityName +
                            "\n\n"
                    );
                });
            })
            .catch((err) => console.error(err));
    };
    useEffect(() => {
        getTeamLeader();
        getTeamDetails();
        // eslint-disable-next-line
    }, [teamId]);
    return (
        <>
            <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${teamId}`}
                            aria-expanded="true"
                            aria-controls="collapseOne"
                        >
                            <tr className="row w-100">
                                <td className="col-sm-2">
                                    {teamLeader.userName}(Leader)
                                </td>
                                <td className="col-sm-1 px-2">
                                    {teamLeader.MI_NO}
                                </td>
                                <td className="col-sm-1 px-2">
                                    {teamLeader.phone}
                                </td>
                                <td className="col-sm-3 px-2">
                                    {teamLeader.email}
                                </td>
                                <td className="col-sm-2 px-2">
                                    {teamLeader.collegeName}
                                </td>
                                <td className="col-sm-1 px-2">
                                    {teamLeader.cityName}
                                </td>
                            </tr>
                        </button>
                    </h2>
                    <div
                        id={teamId}
                        class="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                    >
                        <div class="accordion-body">
                            {teamMembers.map((member) => {
                                return (
                                    <tr className="row">
                                        <td className="col-sm-2">
                                            {member.userName}
                                        </td>
                                        <td className="col-sm-1">
                                            {member.MI_NO}
                                        </td>
                                        <td className="col-sm-1">
                                            {member.phone}
                                        </td>
                                        <td className="col-sm-3">
                                            {member.email}
                                        </td>
                                        <td className="col-sm-2">
                                            {member.collegeName}
                                        </td>
                                        <td className="col-sm-1">
                                            {member.cityName}
                                        </td>
                                    </tr>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </>
    );
};

export default TeamDetails;
